import React from 'react'
import { compareAsc } from 'date-fns'
import { formatDate } from '@awell/ui-kit/utils'
import { Activity } from './types'
import { createSubActivityIcon } from './ActivityDetailHelpers/getActivityEventAvatar'
import { createSubActivitySummaryText } from './ActivityDetailHelpers/getSubActivitySummaryText'

interface Props {
  activity: Activity
}

export const UpdatesTab: React.FC<Props> = ({ activity }) => {
  const sortedSubActivities = [...activity.sub_activities].sort((a, b) =>
    compareAsc(new Date(a.date), new Date(b.date))
  )

  return (
    <div className="flex flex-col gap-4 w-full">
      <div className="flex flex-col gap-2">
        <div className="text-lg font-medium text-gray-900">Updates</div>
        <div className="text-base text-gray-500">Overview of all updates to this activity</div>
      </div>

      <div className="relative">
        <div className="flex max-w-md flex-col gap-y-1">
          {sortedSubActivities.map(subActivity => {
            return (
              <div key={subActivity.id} className="relative flex gap-x-3">
                <div className="flex flex-col gap-y-1">
                  <div className="relative z-10 flex-shrink-0 w-[32px] h-[32px] min-w-[32px] min-h-[32px] border border-slate-200 bg-white rounded-full flex items-center justify-center">
                    {createSubActivityIcon(activity.object.type, subActivity, activity?.icon_url ?? undefined)}
                  </div>
                  <div className="flex flex-1 justify-center">
                    <div className="w-[3px] h-full bg-slate-300 rounded-full"></div>
                  </div>
                </div>

                {/* Timeline content */}
                <div className="flex flex-col pb-6">
                  <div className="flex flex-col gap-y-1">
                    <div className="whitespace-pre-wrap text-base font-normal text-gray-900">
                      {createSubActivitySummaryText(
                        sortedSubActivities,
                        subActivity,
                        activity.object,
                        activity?.indirect_object ?? undefined
                      )}
                    </div>
                    <div className="text-sm text-gray-500">
                      {formatDate({
                        isoDateStr: subActivity.date,
                        dateFormat: 'dd MMM yyyy, h:mm:ss a'
                      })}
                    </div>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
